import React from "react";
import { Link, useLocation } from "react-router-dom";
import "../css/UnderConstruction.css";

export default function UnderConstruction() {
  const location = useLocation();

  return (
    <section className="uc-wrap card-reveal">
      <div className="uc-accent" aria-hidden="true" />
      <h2 className="uc-title">Under construction</h2>
      <p className="uc-desc">
        This page isn’t ready yet. Please check back soon.
      </p>
      <p className="uc-path" aria-label="Requested path">
        {location.pathname}
      </p>

      <div className="uc-actions">
        <Link to="/" className="uc-btn uc-btn--ghost">
          Back to site
        </Link>
      </div>
    </section>
  );
}

